// Shared "is this technician allowed on this job?" logic, used by the
// Assign Technician control on the Job detail page and the Dispatch Board.
const DOW_ABBR = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export function getDisqualifyReasons(tech, job) {
  const reasons = [];
  if (!tech || !job) return reasons;

  if (job.trade && job.type) {
    const q = tech.qualifications?.[job.trade];
    const ok = !!(q?.active && Array.isArray(q.subCategories) && q.subCategories.includes(job.type));
    if (!ok) reasons.push("Technician is not approved for this type of job.");
  }

  if (job.start) {
    const d = new Date(job.start);
    if (!Number.isNaN(d.getTime())) {
      const dayKey = DOW_ABBR[d.getDay()];
      const sched = tech.schedule?.[dayKey];
      if (!sched?.active) reasons.push("Technician is not scheduled for this date.");
    }
  }

  return reasons;
}

export function isQualifiedForJob(tech, job) {
  return getDisqualifyReasons(tech, job).length === 0;
}
